import { z } from 'zod';
import {
    qualityRequirementsPolicySchema,
    qualityRequirementsPolicyListSchema,
} from '../../../schemas/qualityRequirementsPolicy.schemas';
import { createResponseSchema } from '../../../schemas/repository.schemas';

export const qualityRequirementsPolicyListResponseSchema = createResponseSchema(
    qualityRequirementsPolicyListSchema,
);
export type QualityRequirementsPolicyListResponseType = z.infer<
    typeof qualityRequirementsPolicyListResponseSchema
>;

export const qualityRequirementsPolicyResponseSchema = createResponseSchema(
    qualityRequirementsPolicySchema,
);
export type QualityRequirementsPolicyResponseType = z.infer<
    typeof qualityRequirementsPolicyResponseSchema
>;
